import React from "react";

class Program extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "CAAIE 2026 | Programme - Conference on Advanced Artificial Intelligence and Education (CAAIE)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Programme </h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <h4>Programme</h4>
                  </div>
                  <div className="row speakers_row">
                    {" "}
                    <a
                      href="https://www.caaie.org/files/CAAIE_2026.pdf"
                      target="_blank"
                    >
                      CAAIE Programme (Hybrid)
                    </a>
                  </div>
                  <div className="row speakers_row">
                    Please note, that in person sessions will be held at Meeting
                    Room: 1st Floor, Sophia Suite:
                    <p>
                      <br></br>
                      <h4>Hilton Cardiff,</h4>
                      <h5>Kingsway, Greyfriars Rd, Cardiff CF10 3HH, UK </h5>
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3057.2754064115584!2d-3.181090823036521!3d51.48306931247997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486e1cb07d15b5ff%3A0x6ecede4a35fed70e!2sHilton%20Cardiff!5e1!3m2!1sen!2suk!4v1765963472566!5m2!1sen!2suk"
                        width="600"
                        height="450"
                        style={{ border: "0" }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                      <br></br>
                    </p>
                  </div>
                  <div className="row speakers_row">
                    <ul>
                      {/*  <li>TBA</li>
                      <li>
                        {" "}


                        <a
                          href="https://www.icita.world/files/ICITA_2025.pdf"
                          target="_blank"
                        >
                          ICITA 2025 Programme
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Program;
